import ProductSingle from '../../components/products/product-single-container.vue';
export default {
    path: '/products/:id',
    component: ProductSingle,
    meta: {
        requiresAuth: true,
        hideFooter: true,
    }
};